import { utility, Button, Dialog } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';
import { open_in_new_tab } from '@phi/util/window';
import { IAuthentication } from '.';

export const MustLoginModal = defineComponent({
    props: {
        auth: {
            required: true,
            type: Object as PropType<IAuthentication>,
        }
    },

    setup({
        auth: { showing_must_login_modal, hide_must_login_modal },
    }) {
        const instructions_url = 'https://phi3d.com/instructions/';

        function go_to_instructions() {
            open_in_new_tab(instructions_url);
        }

        return () => h(Dialog, {
            id: 'must-login-modal',
            title: 'User is not logged in',
            show: showing_must_login_modal.value,
            'onUpdate:show': x => showing_must_login_modal.value = x,
            onClose: hide_must_login_modal,
            confirm_label: null,
        }, () => h('div', { class: utility.center }, [
            h('p', 'This functionality is unavailable in Guest mode. Please authenticate through Onshape.'),

            h('p', [
                'Don\'t have an Onshape account? You can follow ',
                h('a', { target: '_blank', href: instructions_url }, 'these instructions'),
                '.',
            ]),

            h(Button, {
                variant: 'primary',
                onClick: go_to_instructions,
            }, () => 'Create a FREE Onshape account'),
        ]));
    }
});
